import * as _ from 'underscore';
import { ID } from '../../const';
import { Templates } from '../../compile';
import { BaseConnectionClient } from '../interface';
import { ConnectionSection } from '../connections';
import { ListView } from 'mappMvc/models/views';
import { IConnectionListItem } from 'mappClient/models';
import { ConnectionContentClient, ManagementClient } from 'mappClient/clients';
import { ViewOptions, ListViewOptions } from 'mappMvc/interfaces/options';
import { DefaultTableCommandColumnOptions } from 'mappMvc/const/defaultOptions';
import { Localization } from 'mappMvc/compile';

export class ConnectionList extends ListView<IConnectionListItem> {
	private client: ConnectionContentClient | ManagementClient;
	constructor(client: ConnectionContentClient | ManagementClient, options: ViewOptions) {
		var listViewOptions: ListViewOptions<IConnectionListItem> = {
			view: {
				viewId: ID.All
			},
			table: {
				dataSource: {
					get: (<BaseConnectionClient>client).getConnections
				},
				properties: [
					{ key: 'connectionString', label: Localization.Studio.Connection.Connection },
					{ key: 'providerType', label: Localization.Studio.Connection.Source },
					DefaultTableCommandColumnOptions<IConnectionListItem>()
				]
			}
		};

		_.extend(listViewOptions.view, options);
		super(listViewOptions);
		this.client = client;
	}

	public new() {
		(<ConnectionSection>this.parent).new();
	}

	public edit(connection: IConnectionListItem) {
		(<ConnectionSection>this.parent).edit(connection);
	}

	public delete(copyrightListItem: IConnectionListItem): JQueryPromise<any> {
		return (<BaseConnectionClient>this.client).deleteConnection(copyrightListItem.id);
	}
}
